import {connect} from 'react-redux';
import './DataUpdate.scss';
import DataUpdate from './DataUpdate.lazy';
import PropTypes from 'prop-types';

const mapStateToProps = (state, ownProps) => {
  const {pageContext, propertyContext, propertyId, comparableType, disabled} = ownProps;
  return {
    ...ownProps,
    pageContext,
    propertyContext,
    propertyId,
    comparableType,
    disabled,
  };
};

const mapDispatchToProps = (_) => {
  return {};
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const DataUpdateContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(DataUpdate);

DataUpdateContainer.propTypes = {
  pageContext: PropTypes.string,
  propertyContext: PropTypes.string,
  propertyId: PropTypes.number,
  comparableType: PropTypes.string,
  disabled: PropTypes.bool,
};
export {DataUpdateContainer, DataUpdate};
export default DataUpdateContainer;